module.exports = "/assets/data/fbab44bfa2f602e50e24b3b0aa88a78f-ML6.data.json";